 import React from "react";
import WhatsAppIcon from "./whatsappIcon";
import { FaWhatsapp } from "react-icons/fa";


const WhatsAppButton = () => {
    const phoneNumber = "	+917510266377";
    const message = "Hello, I need assistance!";
    
    const handleClick = () => {
      const url = `https://wa.me/${phoneNumber}?text=${encodeURIComponent(message)}`;
      window.open(url, "_blank");
    };
  
    return (
        <button 
        onClick={handleClick} 
         className="btn  position-fixed bottom-4 end-4  shadow-lg"
         style={{
          bottom: "10px", 
          right: "20px",   
          width: "60px",   
          height: "60px",  
          zIndex: 1000, 
          // backgroundColor: "#25d366", // WhatsApp Green
          color: "white", // Icon color   
        }}
        // className="btn btn-primary position-fixed  d-flex align-items-center gap-2 px-3 py-2 rounded-pill shadow"
      >
         <FaWhatsapp size={24}/>
       {/* <WhatsAppIcon size={50} color="green" /> */}
      </button>
    );
  };
  
  export default WhatsAppButton;
  